import React, { useRef, useLayoutEffect } from 'react';
import './style.scss';

const Layer = ({ layer, duration: totalDuration, index, onUpdate, layerContainerRef }) => {
  const layerRef = useRef();
  useLayoutEffect(() => {
    let startX;

    const onDrag = (event) => {
      const currentLayerBound = layerRef.current.getBoundingClientRect();
      const deltaX = event.clientX - startX;
      const totalLength = (currentLayerBound.width / layer.duration) * totalDuration;
      const newDurationPercent = (layer.at / totalDuration + deltaX / totalLength) * 100;
      if (newDurationPercent >= 0 && newDurationPercent <= 100) {
        layerRef.current.style.left = `${newDurationPercent}%`;
      }
      event.preventDefault();
      event.stopPropagation();
    };

    const onDragEnd = (event) => {
      const currentLayerBound = layerRef.current.getBoundingClientRect();
      const deltaX = event.clientX - startX;
      const totalLength = (currentLayerBound.width / layer.duration) * totalDuration;
      const newDurationPercent = (layer.at / totalDuration + deltaX / totalLength) * 100;
      if (newDurationPercent >= 0 && newDurationPercent <= 100) {
        layerRef.current.style.left = `${newDurationPercent}%`;
        onUpdate({ id: layer.id, at: (newDurationPercent * totalDuration) / 100 });
      }
      document.onmousemove = null;
      document.onmouseup = null;
      event.preventDefault();
      event.stopPropagation();
    };

    const onDragStart = (event) => {
      startX = event.clientX;
      document.onmousemove = onDrag;
      document.onmouseup = onDragEnd;
      event.preventDefault();
      event.stopPropagation();
    };

    layerRef.current.addEventListener('mousedown', onDragStart);

    return () => {
      document.removeEventListener('mousemove', onDrag);
    };
  });
  return (
    <div className={'total'} key={layer.id}>
      <div
        ref={layerRef}
        key={layer.id}
        className={'layer'}
        style={{ left: `${(layer.at / totalDuration) * 100}%`, width: `${(layer.duration / totalDuration) * 100}%` }}></div>
    </div>
  );
};

const LayerInfo = ({ layer, onUpdate }) => {
  return (
    <div className={'layer-info'} key={layer.id}>
      <div
        contentEditable={true}
        className={'name'}
        onBlur={(event) => {
          onUpdate({ id: layer.id, name: event.target.innerHTML });
        }}>
        {layer.name ? layer.name : 'New Layer'}
      </div>
    </div>
  );
};

export const Layers = ({ layers, duration, current = 0, onUpdate }) => {
  return (
    <div className={'layers-container'}>
      <div className={'layer-names'}>
        {layers.map((layer, index) => (
          <LayerInfo layer={layer} duration={duration} index={index} onUpdate={onUpdate} />
        ))}
      </div>
      <div className={'layers'}>
        <div className={'time-marker'} style={{ left: `${(current / duration) * 100}%` }}></div>
        {layers.map((layer, index) => (
          <Layer layer={layer} duration={duration} index={index} onUpdate={onUpdate} />
        ))}
      </div>
    </div>
  );
};
